<template>
  <div style="display: inline-block;margin-right: 10px;">
<!--    暂时隐藏关联子订单-->
    <el-button v-if="false" type="primary" size="mini" @click='handleShowDrawer'>
      关联子订单
    </el-button>
    <el-dialog :visible.sync='show' title="关联子订单" custom-class='append-child-drawer'>
      <p style='text-align: center;'>将常规订单，变成{{ project.order_no }}全案下的子订单。</p>
      <div style='text-align: center;'>
        <el-input v-model='order_no' placeholder='请输入订单编号' size='medium' style='width: 300px;'>
          <el-button slot='append' type='primary' icon='el-icon-search' @click='handleSearch'/>
        </el-input>
      </div>
      <template v-if='order_no&&searched'>
        <template v-if='trade'>
          <div class="main">
            <div class="info">
              <div><span>客户：</span><span>{{ trade.customer_name || '-' }}</span></div>
              <div><span>订单编号：</span><span>{{ trade.order_no || '-' }}</span></div>
              <div><span>销售：</span><span>{{ trade.sale || '-' }}</span></div>
              <div><span>产品名称：</span><span>{{ trade.product || '-' }}</span></div>
              <div><span>含税收入：</span><span>{{ trade.payment_account|numberFormat(2) }}</span></div>
              <div><span>建单时间：</span><span>{{ trade.created_at || '-' }}</span></div>
            </div>
          </div>
          <el-alert title="确认关联后，订单乙方信息、客户信息会重置，请检查仔细。" type="info" center :closable="false"/>
          <button-submit button-txt="确认关联" type="primary" @click.native.prevent="handleSure"
                         style="display: block;margin: 20px auto 0 auto;"/>
        </template>
        <el-empty v-else description='查不到该订单'/>
      </template>
      <el-empty v-else-if='order_no' description='请点击查询'/>
      <el-empty v-else description='请输入订单编号'/>
    </el-dialog>
  </div>
</template>
<script>
import {appendChildOrders, orderDetailTini} from "@/api/adOrder";

export default {
  name: 'AppendChildOrders',
  props: {
    pid: {
      type: [Number, String],
      required: true
    },
    project: {
      type: [Object],
      required: true
    },
  },
  data() {
    return {
      show: false,
      searched: false,
      order_no: null,
      trade: false
    }
  },
  watch:{
    order_no:function () {
      this.searched = false
    }
  },
  methods: {
    handleShowDrawer: function () {
      this.order_no = null
      this.show = true
      this.searched = false
    },
    handleSearch: async function () {
      this.trade = false
      const {model} = await orderDetailTini(this.order_no, ['customer_name', 'order_no', 'sale', 'product', 'payment_account', 'created_at'])
      this.searched = true
      this.trade = model || false
    },
    handleSure: async function () {
      this.$confirm('确认关联后，订单乙方信息、客户信息会重置，请检查仔细。 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const response = await appendChildOrders({order_no: this.order_no, project_no: this.project.order_no})
        if (!response.success) {
          this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
          return;
        }
        this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
        this.show = false
        this.$emit('success')
      }).catch(() => {
      });
    }
  }
}

</script>
<style lang="scss">
.append-child-drawer {
  width: 500px !important;
  border-radius: 20px !important;

  .main {
    margin: 28px 0;

    .info {
      div {
        font-size: 14px;
        color: #8a8e99;
        line-height: 20px;

        span:first-child {
          margin-right: 4px;
          width: 40%;
          display: inline-block;
          text-align: right;
        }

        span:last-child {
          color: rgba(0, 0, 0, 0.85);
        }
      }
    }
  }
}
</style>
